<template>
  <label
    :class="{
      'oai-StructureCard-selected': isSelected,
      'oai-StructureCard-recommended': option.recommended
    }"
    class="oai-StructureCard"
  >
    <input
      v-model="model"
      :name="name"
      :value="value"
      class="oai-StructureCard_Input"
      hidden
      type="radio"
    />

    <span class="oai-StructureCard_Body">
      <span class="oai-StructureCard_Header">
        <span class="oai-StructureCard_Title">{{ option.title }}</span>
        <span class="oai-StructureCard_Employees">{{ option.employees }}</span>
      </span>

      <span class="oai-StructureCard_Layers">
        <template v-for="(layer, index) in option.layers" :key="layer">
          <AppTag
            :content="layer"
            class="oai-StructureCard_Tag"
            content-background="var(--primary-color-next-100)"
            content-color="var(--primary-color)"
          />
          <AppIcon
            v-if="index < option.layers.length - 1"
            class="oai-StructureCard_Arrow"
            height="24"
            icon-name="arrow-right-next"
            width="24"
          />
        </template>
      </span>

      <span class="oai-StructureCard_Description">{{ option.description }}</span>
    </span>
  </label>
</template>

<script setup>
import { computed } from 'vue'

import AppIcon from '@/components/ui/AppIcon/AppIcon'
import AppTag from '@/components/ui/AppTag/AppTag'

defineOptions({
  name: 'OnboardingAiStructureOptionCard'
})

const props = defineProps({
  /**
   * @type {Object}
   * @property {string} title
   * @property {string} employees
   * @property {Array} layers
   * @property {string} description
   * @property {boolean} recommended
   */
  option: {
    type: Object,
    required: true
  },

  value: {
    type: String,
    required: true
  },

  name: {
    type: String,
    required: true
  }
})

const model = defineModel({ type: String })

const isSelected = computed(() => model.value === props.value)
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/gradient-border';
@import '~@/assets/styles/onboarding-ai-step';

.oai-StructureCard {
  display: flex;
  align-items: flex-start;
  width: 100%;
  padding: 24px;
  border: 2px solid $white;
  background: $white;
  cursor: pointer;

  &-selected {
    border: none;
    border-radius: 14px;
    background: $oai-bg;

    box-shadow: 0 0 0 1px $oai-outline;
  }

  &-recommended {
    border: none;
  }
}

.oai-StructureCard_Input {
  position: absolute;
  opacity: 0;
  pointer-events: none;
}

.oai-StructureCard_Body {
  display: grid;
  gap: 12px;
  flex: 1;
}

.oai-StructureCard_Header {
  display: flex;
  justify-content: space-between;
  gap: 12px;
}

.oai-StructureCard_Title {
  font-size: $fs-14;
  line-height: 20px;
  font-weight: fw('semi-bold');
  color: $dark-grey;
}

.oai-StructureCard_Employees {
  flex-shrink: 0;
  font-size: $fs-12;
  line-height: 18px;
  font-weight: fw('regular');
  color: $oai-text-muted;
}

.oai-StructureCard_Layers {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 4px;
}

.oai-StructureCard_Tag {
  font-size: $fs-12;
  padding: 4px 6px;
  line-height: 18px;
  font-weight: fw('regular');
  text-transform: none;
}

.oai-StructureCard_Arrow {
  flex-shrink: 0;
  color: $oai-icon-text;
}

.oai-StructureCard_Description {
  font-size: $fs-12;
  line-height: 18px;
  font-weight: fw('regular');
  color: $oai-text-muted;
  text-align: left;
}
</style>
